<div class="header" mat-dialog-actions>
    <div class="navigation desktop">
        <div class="left">

        </div>
        <div class="middle">

        </div>
        <div class="right">
            <button mat-button mat-dialog-close>Close</button>
        </div>
    </div>

    <div class="navigation mobile">
        <div class="left">
            <button mat-button mat-dialog-close><mat-icon>arrow_back</mat-icon></button>
        </div>
        <div class="middle">

        </div>
        <div class="right">
        </div>
    </div>
</div>

<div mat-dialog-content class="content">
    {{dateRange.start | date}} to {{dateRange.end | date}}

    <!-- <div>Total Expense: {{totalExpense | human}}<br></div> -->
    <div>GST on Purchases (1B): {{gstOnExpenses | human:true}}</div>
    <ul>
        <li *ngFor="let category of atoCategorieTotals">
            <strong>{{getCategoryName(category.category)}}</strong> ({{category.amount | human}})
        </li>
    </ul>
</div>